import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ProductSliderSection from '../common/ProductSliderSection'
import { getHomepageConfig } from '../../services/homepage.service'
import { productService } from '../../services/product.service'

const NewArrivalsSection = () => {
    const { t } = useTranslation();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            try {
                // 1. Get Config
                const config = await getHomepageConfig();
                const selectedIds = config.newArrivalsProductIds || [];

                let validProducts = [];

                // 2. If Admin Selected IDs exist, fetch those specific products
                if (selectedIds.length > 0) {
                    const promises = selectedIds.map(id => productService.getProductById(id));
                    const results = await Promise.all(promises);
                    // Only show active products that exist
                    validProducts = results.filter(p => p && p.isActive);
                }

                // 3. Fallback or use selected
                if (validProducts.length > 0) {
                    setProducts(validProducts);
                } else {
                    // Fallback: Automated Logic (Newest 8 items)
                    const fallback = await productService.getRecentProducts(8);
                    setProducts(fallback);
                }
            } catch (err) {
                console.error("Error loading new arrivals:", err);
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, []);

    if (products.length === 0 && !loading) return null;

    return (
        <ProductSliderSection
            title={t('home.newArrivals.title')}
            subtitle={t('home.newArrivals.subtitle')}
            products={products}
            viewAllHref="/all-product?sort=new"
            bgColor="bg-transparent"
        />
    );
};

export default NewArrivalsSection;
